import StorefrontRoundedIcon from '@mui/icons-material/StorefrontRounded';

export default function POIUpdates() {
  return (
    <div className="agents-section" dir="rtl">
      <header className="agents-section-head">
        <div><h2>نقاط فعالیتی</h2><p>ثبت و تأیید وضعیت خدمات و کسب‌وکارهای محلی</p></div>
      </header>
      <div className="agents-empty-state">
        <span><StorefrontRoundedIcon /></span>
        <h3>به‌روزرسانی نقاط فعالیتی</h3>
        <p>این بخش برای ثبت وضعیت عملیاتی، شرایط و دسترس‌پذیری نقاط فعالیتی آماده می‌شود.</p>
        <small>به‌زودی در دسترس</small>
      </div>
    </div>
  );
}
